const FILTER_COUNT_DESKTOP = 7;
const FILTER_COUNT_MOBILE = 5;

export default function CasinoFrontSkeleton({
  columnCount = 7,
  cardCount = 14,
  isMobile = false,
  gamesOnly = false,
}) {
  const filterCount = isMobile ? FILTER_COUNT_MOBILE : FILTER_COUNT_DESKTOP;
  const cols = Math.max(2, columnCount);
  const cards = Math.max(cols, cardCount);

  const games = (
    <div
      className="casino-front-skeleton__games"
      style={{ '--column-count': cols }}
    >
      {Array.from({ length: cards }, (_, i) => (
        <div key={i} className="casino-front-skeleton__game-card">
          <div className="casino-front-skeleton__game" />
          <div className="casino-front-skeleton__card-label">
            <div className="casino-front-skeleton__card-name" />
            <div className="casino-front-skeleton__card-dev" />
          </div>
        </div>
      ))}
    </div>
  );

  if (gamesOnly) {
    return (
      <div
        className={`casino-front-skeleton casino-front-skeleton--games-only${isMobile ? ' casino-front-skeleton--mobile' : ''}`}
        aria-busy="true"
        aria-hidden="true"
      >
        {games}
      </div>
    );
  }

  return (
    <div
      className={`casino-front-skeleton${isMobile ? ' casino-front-skeleton--mobile' : ''}`}
      aria-busy="true"
      aria-hidden="true"
    >
      <div className="casino-front-skeleton__modes" />
      <div className="casino-front-skeleton__filter">
        {Array.from({ length: filterCount }, (_, i) => (
          <div key={i} className="casino-front-skeleton__filter-item">
            <div className="casino-front-skeleton__filter-icon" />
            <div className="casino-front-skeleton__filter-name" />
          </div>
        ))}
        {!isMobile ? <div className="casino-front-skeleton__search" /> : null}
      </div>
      {games}
    </div>
  );
}
